<template>
    <div id="loader" v-if="display">
        <div id="background"></div>
        <div id="content">
            <div>
                <loaderAnimation/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      display: false
    }
  },
  methods: {
    show () {
      this.display = true
    },
    hide () {
      this.display = false
    }
  }
}
</script>

<style scoped>

#loader {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 30;
}

#background {
    background: #000000;
    height: 100%;
    left: 0;
    opacity: 0.7;
    position: absolute;
    top: 0;
    width: 100%;
}

#content {
    display: table;
    height: 100%;
    width: 100%;
}

#content > div {
    display: table-cell;
    height: 100%;
    text-align: center;
    vertical-align: middle;
    width: 100%;
}

#content #loader-animation {
  font-size: 5em;
}

</style>
